import api from './api'
import fileDownload from 'js-file-download'

export default {
  activeSubscribers() {
    return api
      .get('/admin/csv-reports/subscriptions', {
        responseType: 'blob',
      })
      .then(({ data }) => {
        fileDownload(data, `assinantes-${Date.now()}.csv`)
      })
  },
  people(q = {}) {
    return api
      .get('/admin/csv-reports/people', {
        responseType: 'blob',
        params: { q },
      })
      .then(({ data }) => {
        fileDownload(data, `usuarios-${Date.now()}.csv`)
      })
  },
}
